import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface HeaderHeightParameter extends ApiParameter {
    headerHeight?: number;
}

export interface HeaderHeightModel {
    headerHeight?: number;
}

type HandlerType = CustomApiHandler<HeaderHeightParameter, HeaderHeightModel>;

export const DispatchHeaderHeight: HandlerType = (props) => {
    props.dispatch({
        type: "HomePage/SurHeader/SurHeaderHeight",
        result: props.parameter.headerHeight,
    });
};

export const SetHeaderHeightCssVariable: HandlerType = props => {
    const height = props.parameter.headerHeight;
    if (height !== undefined && typeof document !== "undefined") {
        document.documentElement.style.setProperty("--header-height", `${height}px`);
    }
};

export const chain = [DispatchHeaderHeight, SetHeaderHeightCssVariable];
const surHeaderHeight = createHandlerChainRunnerOptionalParameter(chain, {}, "SurHeaderHeight");
export default surHeaderHeight;
